<template>
    <div class="component-wrap profile" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <h1 v-if="user.self" class="section-title-main font-weight-regular" :class="{'mx-3 mt-0 mb-3': $vuetify.breakpoint.xs, 'my-3': $vuetify.breakpoint.smAndUp}">{{ $t('Профиль') }}</h1>
                <v-expansion-panel
                    v-model="value"
                    v-if="$vuetify.breakpoint.xs"
                    expand
                    :class="{'mb-4': $vuetify.breakpoint.smAndDown,'py-5': $vuetify.breakpoint.mdAndUp}"
                >
                    <v-expansion-panel-content
                        expand-icon=""
                        class="px-3 py-0"
                    >
                        <v-layout slot="header">
                            <v-flex>Настройки</v-flex>
                            <roundButton :icon_name="value[0] ? 'minus' : 'plus'" :class="{'btn--icon-white': value[0]}" />
                        </v-layout>
                        <v-card>
                            <ProfileMenu class="pb-3" :full="user.profile_fullness" />
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <ProfileMenu v-if="!$vuetify.breakpoint.xs" :user="$route.params.id ? user_page : user" class="border-bottom"
                             :full="user.profile_fullness"
                />
                <ProfileControl v-if="view_profile_control" class="border-bottom mt-4" :user_page="user_page"
                                :status="user_status"
                />
                <v-flex class="mb-5" :class="{'mt-3': $vuetify.breakpoint.xs, 'mt-5': $vuetify.breakpoint.smAndUp}">
                    <ProfileContent :user_page="$route.params.id ? user_page : user" />
                </v-flex>
            </v-layout>
        </div>
        <v-dialog :value="user_info_admin.active" persistent content-class="scrolled-dialog">
            <userEditAdmin v-if="user_info_admin.active" />
        </v-dialog>
        <v-dialog :value="user_info.active" persistent content-class="scrolled-dialog">
            <modalEditInfo v-if="user_info.active" />
        </v-dialog>
        <v-dialog :value="change_password.active" persistent content-class="scrolled-dialog">
            <modalPasswordChange v-if="change_password.active" />
        </v-dialog>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import ProfileMenu   from './profile_menu.vue';
import ProfileControl   from './profile_control.vue';
import ProfileContent   from './profile_content.vue';
import roundButton   from '@/components/ui/buttons/buttons_icon/round_button';
import userEditAdmin from './user_modals/user_edit_admin';
import modalEditInfo from './user_modals/user_info_edit';
import modalPasswordChange from './user_modals/user_change_password';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    ProfileMenu,
    ProfileControl,
    ProfileContent,
    roundButton,
    userEditAdmin,
    modalEditInfo,
    modalPasswordChange,
  },
  data() {
    return {
      role_code: JSON.parse(localStorage.getItem('user')).role_code,
      user_id  : JSON.parse(localStorage.getItem('user')).id,
      value    : [],
    };
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('profile/other_user', {
      'user_page': 'other_user',
    }),
    view_profile_control() {
      return this.role_code === 'ADMINISTRATOR' && this.$route.name !== 'profile' && this.$route.params.id !== this.user_id;
    },
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('profile/other_user', [
      'other_user',
    ]),
    ...mapGetters('profile/statuses', [
      'user_status',
      'status_confirmed',
      'status_off',
      'status_processing',
      'status_declined',
    ]),
    ...mapGetters('profile/modals', [
      'user_info',
      'user_info_admin',
      'change_password',
    ]),
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.get_other_user(this.$route.params.id);
      await this.replace_company(this.user_page.company_id);
      this.SET_CURRENT_STATUS();
    } else {
      await this.get_load_user();
      await this.replace_company();
      if (localStorage.user != 'undefined') {
        this.REPLACE_USER_PROFILE(JSON.parse(localStorage.getItem('user')));
      }
    }
  },
  methods: {
    ...mapActions('profile/other_user', [
      'get_other_user',
    ]),
    ...mapActions('profile/statuses', [
      'SET_CURRENT_STATUS',
    ]),
    ...mapActions('autorisation', [
      'get_load_user',
    ]),
    ...mapActions('company_profile/info', [
      'replace_company',
    ]),
    ...mapMutations('profile/user', [
      'REPLACE_USER_PROFILE',
    ]),
  },
};
</script>
